const whichTypeSelect = {
  TYPE_CAMPAIGNS: "TYPE_CAMPAIGNS",
  CAMPAIGN: "CAMPAIGN",
};

export default {
  whichTypeSelect,
};
